import * as React from 'react';

import { StyledTextComponent } from "./Typography.styles";










export const Text = ({
  tag: TextComponent = 'div',
  styleMixin,
  styleModifiers = {},
  className,
  children,
  html }) =>
{
  return !html ? /*#__PURE__*/
  React.createElement(StyledTextComponent, {
    tag: TextComponent,
    styleMixin: styleMixin,
    styleModifiers: styleModifiers,
    as: TextComponent,
    className: className },

  children) : /*#__PURE__*/


  React.createElement(StyledTextComponent, {
    tag: TextComponent,
    styleMixin: styleMixin,
    styleModifiers: styleModifiers,
    as: TextComponent,
    dangerouslySetInnerHTML: { __html: html },
    className: className });


};